import apiCall from "../../utils/apiCall";
import {apiUrls} from "../../constants/apiUrls";
import {CreateTypeWastes, UpdateTypeWastes} from "../../types/api/guide/typeWastes.types";

export const typeWastesService = {
    getAll: () =>
        apiCall.get(apiUrls.guide.typeWastes.getAll),

    create: (typeWastes: CreateTypeWastes) =>
        apiCall.post(apiUrls.guide.typeWastes.create, typeWastes),

    update: (id: string, typeWastes: UpdateTypeWastes) =>
        apiCall.put(apiUrls.guide.typeWastes.update(id), typeWastes),

    delete: (id: string) =>
        apiCall.delete(apiUrls.guide.typeWastes.delete(id)),

    getById: (id: string) =>
        apiCall.get(apiUrls.guide.typeWastes.getById(id))
}